import { useTranslate } from '@tolgee/react';
import styled from 'styled-components';

import theme from '../../../assets/theme';

/**
 * Small orange pill that marks a home-page card as "preview" — i.e. not
 * yet released to all teachers. Sits next to the SchoolPlanAccentIcon in
 * `RankedCard`'s top-right marker slot.
 */
export type PreviewBadgeProps = {
  className?: string;
  // Overrides the default "Preview" label (e.g. "Coming soon").
  label?: string;
};

export function PreviewBadge({ className, label }: PreviewBadgeProps) {
  const { t } = useTranslate();
  return <Pill className={className}>{label ?? t('PreviewBadge.Label', 'Preview')}</Pill>;
}

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  padding: 0 6px;
  border-radius: 5px;
  background: ${theme.colors.lightOrangeBg};
  color: ${theme.colors.orange};
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  white-space: nowrap;

  transition: transform 180ms ease, box-shadow 180ms ease;
  transform-origin: center;
  will-change: transform;

  &:hover {
    transform: scale(1.08);
    box-shadow: 0 2px 8px rgba(249, 151, 70, 0.32);
  }
`;
